export default __webpack_public_path__ + "static/media/app-store.18646433.png";